import React from "react";
import { FacilitiesEvolutionContainer } from "../../container/panelReports";

const EvolutionFacilitiesScreen: React.FC<{}> = () => {
  return <FacilitiesEvolutionContainer/>;
}

export default EvolutionFacilitiesScreen;